export const API_ERROR = 'API_ERROR';

// GLOBAL PER VIEW

export const GET_PROPERTY_BY_MONTH = 'GET_PROPERTY_BY_MONTH';
export const GET_PROPERTY_BY_MONTH_SUCCESS = 'GET_PROPERTY_BY_MONTH_SUCCESS';
export const GET_PROPERTY_BY_YEAR = 'GET_PROPERTY_BY_YEAR';
export const GET_PROPERTY_BY_YEAR_SUCCESS = 'GET_PROPERTY_BY_YEAR_SUCCESS';

// RECOMMENDATIONS

export const GET_ALL_RECOMMENDATION = 'GET_ALL_RECOMMENDATION';
export const GET_ALL_RECOMMENDATION_SUCCESS = 'GET_ALL_RECOMMENDATION_SUCCESS';
export const GET_RECOMMENDATION = 'GET_RECOMMENDATION';
export const GET_RECOMMENDATION_SUCCESS = 'GET_RECOMMENDATION_SUCCESS';
export const GET_RECOMMENDATIONS_FOR_RANGE = 'GET_RECOMMENDATIONS_FOR_RANGE';
export const UPDATE_ALL_RECOMMENDATION = 'UPDATE_ALL_RECOMMENDATION';
export const UPDATE_ALL_RECOMMENDATION_SUCCESS = 'UPDATE_ALL_RECOMMENDATION_SUCCESS';
export const UPDATE_RECOMMENDATION = 'UPDATE_RECOMMENDATION';
export const UPDATE_RECOMMENDATION_SUCCESS = 'UPDATE_RECOMMENDATION_SUCCESS';

// WIDGETS

export const GET_BUSINESS_REVIEW_BY_MONTH = 'GET_BUSINESS_REVIEW_BY_MONTH';
export const GET_BUSINESS_REVIEW_BY_MONTH_SUCCESS = 'GET_BUSINESS_REVIEW_BY_MONTH_SUCCESS';

export const GET_OTA_INSIGHTS_DAILY = 'GET_OTA_INSIGHTS_DAILY';
export const GET_OTA_INSIGHTS_DAILY_SUCCESS = 'GET_OTA_INSIGHTS_DAILY_SUCCESS';
export const GET_OTA_INSIGHTS_BY_RANGE = 'GET_OTA_INSIGHTS_BY_RANGE';
export const GET_OTA_INSIGHTS_BY_RANGE_SUCCESS = 'GET_OTA_INSIGHTS_BY_RANGE_SUCCESS';
export const GET_OTA_INSIGHTS_EXPORT = 'GET_OTA_INSIGHTS_EXPORT';
export const GET_OTA_INSIGHTS_EXPORT_SUCCESS = 'GET_OTA_INSIGHTS_EXPORT_SUCCESS';

export const GET_EVENTS_BY_DAY = 'GET_EVENTS_BY_DAY';
export const GET_EVENTS_BY_DAY_SUCCESS = 'GET_EVENTS_BY_DAY_SUCCESS';
export const GET_EVENTS_BY_RANGE = 'GET_EVENTS_BY_RANGE';
export const GET_EVENTS_BY_RANGE_SUCCESS = 'GET_EVENTS_BY_RANGE_SUCCESS';
